const roles = {
    super: 'Super Admin',
    admin: 'Administrador',
    lab: 'Laboratório',
    partner: 'Parceiro',
    client: 'Cliente',
    doctor: 'Médico'
};

export default roles;